import { Link } from "react-router-dom";
import Input from "../../../components/input";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createPasswordResetLink } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import { FiMail, FiArrowLeft } from "react-icons/fi";

const SendPasswordResetLink = () => {
  document.title = "Reset password - CloudVantage";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.user.loading);

  const createPasswordReset = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const { email } = values;
      let passwordResetFormData = {
        email,
      };
      const { payload } = await dispatch(
        createPasswordResetLink({ passwordResetFormData, navigate })
      );
      if (payload.statuscode === "00") {
        resetForm();
        navigate("/");
      }
    },
  });

  return (
    <div className="w-full">
      <div className="mb-10 text-center md:text-left">
        <Link to="/" className="inline-flex items-center text-primaryBlue hover:underline mb-4 text-sm font-medium">
          <FiArrowLeft className="mr-2" /> Back to Login
        </Link>
        <h2 className="text-2xl font-bold dark:text-white mb-2">Reset password</h2>
        <p className="text-gray-400 text-sm">Enter your email to receive a reset link</p>
      </div>

      <form onSubmit={createPasswordReset.handleSubmit} className="grid gap-6">
        <Input
          label="Email address"
          name="email"
          value={createPasswordReset.values.email}
          onBlur={createPasswordReset.handleBlur}
          onChange={createPasswordReset.handleChange}
          placeholder={"Enter your email address"}
          prefixIcon={FiMail}
          onError={
            createPasswordReset.touched.email &&
            createPasswordReset.errors.email
          }
        />
        
        <div className="mt-4">
          <Button
            buttonRole={"submit"}
            loading={loading}
            buttonText={"Send reset link"}
            width="w-full"
            bgColor="bg-primaryBlue text-white w-full py-4 text-lg font-semibold rounded-lg shadow-lg shadow-blue-200 dark:shadow-none transition-transform active:scale-[0.98]"
          />
        </div>
      </form>
    </div>
  );
};

export default SendPasswordResetLink;
